import { TFunction } from 'i18next'

export const listTypes = (t: TFunction<'translation', undefined>) => [
    { key: 'dynamic', label: t('dynamic') },
    { key: 'static', label: t('static') },
]
